import React, { useEffect } from "react";
import { View, Text } from "react-native";
import ErrorViewSvg from "@assets/svg/ErrorView";
import Button from "@components/Button";
import analytics from "@services/analytics";
import { TIMELINE_EVENTS } from "@constants/analyticsEventsCT";
import t from "@constants/localization";

const PATH = "screens/TimelineCrash";

const TimelineCrash = (props) => {
  useEffect(() => {
    analytics.trackEvent(TIMELINE_EVENTS.WALL_CRASH, {});
  }, []);
  return (
    <View style={{ flex: 1, alignItems: "center", justifyContent: "center" }}>
      <ErrorViewSvg />
      <Text variant="subtitle_16" style={{ marginVertical: 15 }}>
        {t(`${PATH}/somethingWentWrong`)}
      </Text>
      <Button
        btnText={t(`${PATH}/tryAgain`)}
        buttonWidth={200}
        height={55}
        onPress={() => {
          if (props.navigation.canGoBack()) {
            props.navigation.goBack();
          } else {
            props.navigation.navigate("Home");
          }
        }}
      />
    </View>
  );
};

export default TimelineCrash;
